



export const applyTransformObject=(
errorObject,
error,
{transformObject})=>
{
try{
transformObject?.(errorObject,error)
}catch{}
};


export const applyTransformInstance=(
error,
errorObject,
{transformInstance})=>
{
try{
transformInstance?.(error,errorObject)
}catch{}
};